import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["paragraph text-base", { '--no-margin': _ctx.noMargin, '--heading': _ctx.heading, '--inner-space': _ctx.innerSpace }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}